import { KEYWORD_UI_UID } from '../constants/keywordUiUid';

export const createUiUID = ({
  keyword = KEYWORD_UI_UID.profilePic,
  orgId,
  streamId,
  channelId,
}) => {
  if (orgId && streamId && channelId) {
    return `${keyword}/${orgId}/${streamId}/${channelId}`;
  }
  if (orgId && streamId) {
    return `${keyword}/${orgId}/${streamId}`;
  }
  if (orgId) {
    return `${keyword}/${orgId}`;
  }
  return `${keyword}`;
};
